import { createContext, useState } from 'react';

import PersonCertificationData from './PersonCertificationData';

export const PersonCertificationStateContext = createContext();

const PersonCertificationContextProvider = ({ children }) => {
  const stateHook = useState(PersonCertificationData.INITIAL_STATE);

  return (
    <PersonCertificationStateContext.Provider value={stateHook}>
      {children}
    </PersonCertificationStateContext.Provider>
  );
};

export default PersonCertificationContextProvider;